module.exports = "<div class=\"container\">\n\t<div class=\"row\">\n\t\t<a class=\"btn btn-info\" routerlink=\"/qualify-product\" routerLinkActive=\"active\">Qualify Product</a>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sachinmacbook/Sites/ngfront/src/app/services-list/services-list.component.html
// module id = ../../../../../src/app/services-list/services-list.component.html
// module chunks = main